"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MARKER_ICONS = exports.MAP_TILES = void 0;
var _react = _interopRequireWildcard(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
// Styles de tuiles gratuits disponibles
const MAP_TILES = exports.MAP_TILES = {
  standard: {
    name: 'Standard',
    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    attribution: '© OpenStreetMap contributors'
  },
  hot: {
    name: 'Humanitaire',
    url: 'https://{s}.tile.openstreetmap.fr/hot/{z}/{x}/{y}.png',
    attribution: '© OpenStreetMap contributors, Tiles style by Humanitarian OSM Team'
  },
  toner: {
    name: 'Noir & Blanc',
    url: 'https://tiles.stadiamaps.com/tiles/stamen_toner/{z}/{x}/{y}.png',
    attribution: '© Stadia Maps © Stamen Design © OpenStreetMap'
  },
  terrain: {
    name: 'Terrain',
    url: 'https://tiles.stadiamaps.com/tiles/stamen_terrain/{z}/{x}/{y}.png',
    attribution: '© Stadia Maps © Stamen Design © OpenStreetMap'
  },
  watercolor: {
    name: 'Aquarelle',
    url: 'https://tiles.stadiamaps.com/tiles/stamen_watercolor/{z}/{x}/{y}.jpg',
    attribution: '© Stadia Maps © Stamen Design © OpenStreetMap'
  },
  dark: {
    name: 'Sombre',
    url: 'https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}.png',
    attribution: '© Stadia Maps © OpenStreetMap'
  },
  satellite: {
    name: 'Satellite',
    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
    attribution: '© Esri, Maxar, Earthstar Geographics'
  },
  streets: {
    name: 'Rues',
    url: 'https://tiles.stadiamaps.com/tiles/osm_bright/{z}/{x}/{y}.png',
    attribution: '© Stadia Maps © OpenStreetMap'
  }
};

// Icônes de marqueur prédéfinies
const MARKER_ICONS = exports.MARKER_ICONS = {
  pin: '📍',
  restaurant: '🍽️',
  cafe: '☕',
  bar: '🍺',
  hotel: '🏨',
  shop: '🛒',
  heart: '❤️',
  star: '⭐',
  home: '🏠',
  building: '🏢',
  parking: '🅿️',
  gas: '⛽',
  hospital: '🏥',
  school: '🎓',
  park: '🌳',
  beach: '🏖️',
  mountain: '⛰️',
  custom: '📌'
};

// Composant de carte statique (sans Leaflet, utilise une image)
const StaticMap = ({
  latitude,
  longitude,
  zoom,
  width,
  height,
  markers = [],
  mapStyle
}) => {
  // Utilise l'API OpenStreetMap Static Map
  const baseUrl = 'https://staticmap.openstreetmap.de/staticmap.php';
  const safeMarkers = Array.isArray(markers) ? markers : [];
  const markerString = safeMarkers.map(m => `${m.longitude},${m.latitude},red`).join('|');
  const mapUrl = `${baseUrl}?center=${latitude},${longitude}&zoom=${zoom}&size=${Math.round(width)}x${Math.round(height)}&maptype=mapnik${safeMarkers.length ? `&markers=${markerString}` : ''}`;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("img", {
    src: mapUrl,
    alt: "Carte",
    style: {
      width: '100%',
      height: '100%',
      objectFit: 'cover'
    },
    loading: "lazy"
  });
};

// Composant de carte interactive avec iframe OpenStreetMap
const InteractiveMapIframe = ({
  latitude,
  longitude,
  zoom,
  showMarker,
  mapStyle
}) => {
  const bbox = (0, _react.useMemo)(() => {
    // Calcul approximatif de la bounding box basé sur le zoom
    const latDelta = 180 / Math.pow(2, zoom);
    const lonDelta = 360 / Math.pow(2, zoom);
    return {
      left: longitude - lonDelta,
      bottom: latitude - latDelta,
      right: longitude + lonDelta,
      top: latitude + latDelta
    };
  }, [latitude, longitude, zoom]);
  const iframeUrl = `https://www.openstreetmap.org/export/embed.html?bbox=${bbox.left}%2C${bbox.bottom}%2C${bbox.right}%2C${bbox.top}&layer=mapnik${showMarker ? `&marker=${latitude}%2C${longitude}` : ''}`;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("iframe", {
    src: iframeUrl,
    style: {
      width: '100%',
      height: '100%',
      border: 'none'
    },
    allowFullScreen: true,
    loading: "lazy",
    referrerPolicy: "no-referrer-when-downgrade",
    title: "Carte OpenStreetMap"
  });
};

// Composant de carte interactive avec Leaflet (chargé dynamiquement)
const InteractiveMapLeaflet = ({
  latitude,
  longitude,
  zoom,
  mapStyle,
  markers = [],
  showZoomControls,
  showAttribution,
  draggable,
  scrollWheelZoom,
  onMapClick,
  scaleFactor = 1
}) => {
  const mapRef = (0, _react.useRef)(null);
  const mapInstanceRef = (0, _react.useRef)(null);
  const markersRef = (0, _react.useRef)([]);
  const [leafletLoaded, setLeafletLoaded] = (0, _react.useState)(false);
  const [error, setError] = (0, _react.useState)(null);

  // Charger Leaflet dynamiquement
  (0, _react.useEffect)(() => {
    if (window.L) {
      setLeafletLoaded(true);
      return;
    }

    // Charger le CSS
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css';
    link.integrity = 'sha256-p4NxAoJBhIIN+hmNHrzRCf9tD/miZyoHS5obTRR9BMY=';
    link.crossOrigin = '';
    document.head.appendChild(link);

    // Charger le JS
    const script = document.createElement('script');
    script.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js';
    script.integrity = 'sha256-20nQCchB9co0qIjJZRGuk2/Z9VM+kNiyxNV1lvTlZBo=';
    script.crossOrigin = '';
    script.async = true;
    script.onload = () => setLeafletLoaded(true);
    script.onerror = () => setError('Impossible de charger la carte');
    document.head.appendChild(script);
    return () => {
      // Cleanup si nécessaire
    };
  }, []);

  // Initialiser la carte
  (0, _react.useEffect)(() => {
    if (!leafletLoaded || !mapRef.current || !window.L) return;

    // Détruire la carte existante
    if (mapInstanceRef.current) {
      mapInstanceRef.current.remove();
    }
    const L = window.L;
    const tileConfig = MAP_TILES[mapStyle] || MAP_TILES.standard;

    // Créer la carte
    const map = L.map(mapRef.current, {
      center: [latitude, longitude],
      zoom: zoom,
      zoomControl: showZoomControls,
      attributionControl: showAttribution,
      dragging: draggable,
      scrollWheelZoom: scrollWheelZoom,
      doubleClickZoom: draggable,
      touchZoom: draggable
    });

    // Ajouter les tuiles
    L.tileLayer(tileConfig.url, {
      attribution: showAttribution ? tileConfig.attribution : '',
      maxZoom: 19
    }).addTo(map);

    // Ajouter les marqueurs
    markersRef.current.forEach(m => m.remove());
    markersRef.current = [];
    const safeMarkers = Array.isArray(markers) ? markers : [];
    safeMarkers.forEach(marker => {
      const icon = L.divIcon({
        html: `<div style="
                    font-size: ${24 * scaleFactor}px;
                    text-align: center;
                    filter: drop-shadow(2px 2px 2px rgba(0,0,0,0.3));
                ">${marker.icon || '📍'}</div>`,
        className: 'custom-marker-icon',
        iconSize: [40 * scaleFactor, 40 * scaleFactor],
        iconAnchor: [20 * scaleFactor, 40 * scaleFactor]
      });
      const leafletMarker = L.marker([marker.latitude, marker.longitude], {
        icon
      }).addTo(map);
      if (marker.popup) {
        leafletMarker.bindPopup(`
                    <div style="
                        font-family: system-ui, sans-serif;
                        padding: 8px;
                        min-width: 150px;
                    ">
                        ${marker.title ? `<strong style="font-size: 14px; color: #333;">${marker.title}</strong><br/>` : ''}
                        ${marker.popup}
                    </div>
                `);
      }
      markersRef.current.push(leafletMarker);
    });

    // Click handler
    if (onMapClick) {
      map.on('click', e => {
        onMapClick({
          latitude: e.latlng.lat,
          longitude: e.latlng.lng
        });
      });
    }
    mapInstanceRef.current = map;
    return () => {
      if (mapInstanceRef.current) {
        mapInstanceRef.current.remove();
        mapInstanceRef.current = null;
      }
    };
  }, [leafletLoaded, latitude, longitude, zoom, mapStyle, markers, showZoomControls, showAttribution, draggable, scrollWheelZoom, scaleFactor]);

  // Mettre à jour la vue quand les coordonnées changent
  (0, _react.useEffect)(() => {
    if (mapInstanceRef.current) {
      mapInstanceRef.current.setView([latitude, longitude], zoom);
    }
  }, [latitude, longitude, zoom]);
  if (error) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#f0f0f0',
        color: '#666',
        fontFamily: 'system-ui, sans-serif'
      },
      children: error
    });
  }
  if (!leafletLoaded) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #e8f4f8 0%, #d4e8ed 100%)',
        fontFamily: 'system-ui, sans-serif'
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: {
          textAlign: 'center'
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            fontSize: 40,
            marginBottom: 10,
            animation: 'pulse 1.5s infinite'
          },
          children: "\uD83D\uDDFA\uFE0F"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          style: {
            color: '#666'
          },
          children: "Chargement de la carte..."
        })]
      })
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    ref: mapRef,
    style: {
      width: '100%',
      height: '100%'
    }
  });
};

// Normalisation des propriétés de style
const normalizeStylesProperties = props => ({
  // Couleurs
  primary_color: props?.primary_color || '#3B82F6',
  secondary_color: props?.secondary_color || '#1E40AF',
  accent_color: props?.accent_color || '#F59E0B',
  background_color: props?.background_color || '#ffffff',
  text_color: props?.text_color || '#1F2937',
  border_color: props?.border_color || '#E5E7EB',
  // Arrondis et ombres
  border_radius: props?.border_radius ?? 16,
  border_width: props?.border_width ?? 0,
  shadow_intensity: props?.shadow_intensity ?? 'medium',
  // none, light, medium, strong

  // Police
  font_family: props?.font_family || 'system-ui, -apple-system, sans-serif'
});

// Composant principal MapCell
const MapCell = ({
  // Coordonnées
  latitude = 48.8566,
  longitude = 2.3522,
  zoom = 14,
  // Style de carte
  map_style = 'standard',
  map_mode = 'interactive',
  // 'interactive', 'static', 'iframe'

  // Marqueurs
  markers = [],
  show_main_marker = true,
  main_marker_icon = 'pin',
  main_marker_title = '',
  main_marker_popup = '',
  // Contrôles
  show_zoom_controls = true,
  show_attribution = true,
  draggable = true,
  scroll_wheel_zoom = false,
  // Géolocalisation utilisateur
  show_user_location = false,
  show_locate_button = false,
  user_marker_icon = '📍',
  locate_button_text = 'Ma position',
  // Overlay d'informations
  show_info_overlay = false,
  info_title = '',
  info_address = '',
  info_phone = '',
  info_hours = '',
  info_position = 'bottom-left',
  // 'top-left', 'top-right', 'bottom-left', 'bottom-right'

  // Bouton d'itinéraire
  show_directions_button = true,
  directions_button_text = 'Itinéraire',
  // Styles
  styles_properties = {},
  // Dimensions et scale
  width = 400,
  height = 300,
  scaleFactor = 1,
  // Callbacks
  onMapClick,
  onDirectionsClick,
  onUserLocationFound
}) => {
  const styles = normalizeStylesProperties(styles_properties);
  const [isHovered, setIsHovered] = (0, _react.useState)(false);
  const [userLocation, setUserLocation] = (0, _react.useState)(null);
  const [locationError, setLocationError] = (0, _react.useState)(null);
  const [isLocating, setIsLocating] = (0, _react.useState)(false);

  // Obtenir la position de l'utilisateur
  const getUserLocation = () => {
    if (!navigator.geolocation) {
      setLocationError('Géolocalisation non supportée');
      return;
    }
    setIsLocating(true);
    setLocationError(null);
    navigator.geolocation.getCurrentPosition(position => {
      const userPos = {
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
        accuracy: position.coords.accuracy
      };
      setUserLocation(userPos);
      setIsLocating(false);
      if (onUserLocationFound) {
        onUserLocationFound(userPos);
      }
    }, error => {
      setIsLocating(false);
      switch (error.code) {
        case error.PERMISSION_DENIED:
          setLocationError('Accès refusé');
          break;
        case error.POSITION_UNAVAILABLE:
          setLocationError('Position indisponible');
          break;
        case error.TIMEOUT:
          setLocationError('Délai dépassé');
          break;
        default:
          setLocationError('Erreur de localisation');
      }
    }, {
      enableHighAccuracy: true,
      timeout: 10000,
      maximumAge: 60000
    });
  };

  // Charger la position au montage si show_user_location est activé
  (0, _react.useEffect)(() => {
    if (show_user_location) {
      getUserLocation();
    }
  }, [show_user_location]);

  // Construire la liste des marqueurs
  const allMarkers = (0, _react.useMemo)(() => {
    const safeMarkers = Array.isArray(markers) ? markers : [];
    const result = [...safeMarkers];
    if (show_main_marker) {
      result.unshift({
        latitude,
        longitude,
        icon: MARKER_ICONS[main_marker_icon] || main_marker_icon || '📍',
        title: main_marker_title,
        popup: main_marker_popup
      });
    }

    // Ajouter la position de l'utilisateur si disponible
    if (userLocation) {
      result.push({
        latitude: userLocation.latitude,
        longitude: userLocation.longitude,
        icon: user_marker_icon || '🔵',
        title: 'Vous êtes ici',
        popup: 'Votre position actuelle',
        isUserLocation: true
      });
    }
    return result;
  }, [markers, show_main_marker, latitude, longitude, main_marker_icon, main_marker_title, main_marker_popup, userLocation, user_marker_icon]);

  // Générer l'URL Google Maps pour l'itinéraire
  const getDirectionsUrl = () => {
    return `https://www.google.com/maps/dir/?api=1&destination=${latitude},${longitude}`;
  };

  // Gérer le clic sur le bouton itinéraire
  const handleDirectionsClick = () => {
    if (onDirectionsClick) {
      onDirectionsClick({
        latitude,
        longitude,
        url: getDirectionsUrl()
      });
    } else {
      window.open(getDirectionsUrl(), '_blank');
    }
  };

  // Style de l'ombre
  const getShadowStyle = () => {
    switch (styles.shadow_intensity) {
      case 'none':
        return 'none';
      case 'light':
        return '0 2px 8px rgba(0,0,0,0.08)';
      case 'strong':
        return '0 12px 40px rgba(0,0,0,0.2)';
      default:
        return '0 4px 20px rgba(0,0,0,0.12)';
    }
  };

  // Position de l'overlay d'infos
  const getInfoOverlayPosition = () => {
    const positions = {
      'top-left': {
        top: `calc(12px * ${scaleFactor})`,
        left: `calc(12px * ${scaleFactor})`
      },
      'top-right': {
        top: `calc(12px * ${scaleFactor})`,
        right: `calc(12px * ${scaleFactor})`
      },
      'bottom-left': {
        bottom: `calc(12px * ${scaleFactor})`,
        left: `calc(12px * ${scaleFactor})`
      },
      'bottom-right': {
        bottom: `calc(12px * ${scaleFactor})`,
        right: `calc(12px * ${scaleFactor})`
      }
    };
    return positions[info_position] || positions['bottom-left'];
  };

  // Rendu de la carte selon le mode
  const renderMap = () => {
    switch (map_mode) {
      case 'static':
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(StaticMap, {
          latitude: latitude,
          longitude: longitude,
          zoom: zoom,
          width: width,
          height: height,
          markers: allMarkers,
          mapStyle: map_style
        });
      case 'iframe':
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(InteractiveMapIframe, {
          latitude: latitude,
          longitude: longitude,
          zoom: zoom,
          showMarker: show_main_marker,
          mapStyle: map_style
        });
      default:
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(InteractiveMapLeaflet, {
          latitude: latitude,
          longitude: longitude,
          zoom: zoom,
          mapStyle: map_style,
          markers: allMarkers,
          showZoomControls: show_zoom_controls,
          showAttribution: show_attribution,
          draggable: draggable,
          scrollWheelZoom: scroll_wheel_zoom,
          onMapClick: onMapClick,
          scaleFactor: scaleFactor
        });
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    onMouseEnter: () => setIsHovered(true),
    onMouseLeave: () => setIsHovered(false),
    style: {
      width: '100%',
      height: '100%',
      position: 'relative',
      overflow: 'hidden',
      borderRadius: `calc(${styles.border_radius}px * ${scaleFactor})`,
      border: styles.border_width > 0 ? `${styles.border_width}px solid ${styles.border_color}` : 'none',
      boxShadow: getShadowStyle(),
      backgroundColor: styles.background_color,
      fontFamily: styles.font_family,
      transition: 'all 0.3s ease',
      transform: isHovered ? 'scale(1.01)' : 'scale(1)'
    },
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        width: '100%',
        height: '100%'
      },
      children: renderMap()
    }), show_info_overlay && (info_title || info_address || info_phone || info_hours) && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      style: {
        position: 'absolute',
        ...getInfoOverlayPosition(),
        background: 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(10px)',
        borderRadius: `calc(12px * ${scaleFactor})`,
        padding: `calc(16px * ${scaleFactor})`,
        maxWidth: `calc(280px * ${scaleFactor})`,
        boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
        zIndex: 1000
      },
      children: [info_title && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        style: {
          fontSize: `calc(1rem * ${scaleFactor})`,
          fontWeight: '700',
          color: styles.text_color,
          marginBottom: `calc(8px * ${scaleFactor})`
        },
        children: info_title
      }), info_address && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: {
          fontSize: `calc(0.85rem * ${scaleFactor})`,
          color: '#666',
          marginBottom: `calc(6px * ${scaleFactor})`,
          display: 'flex',
          alignItems: 'flex-start',
          gap: `calc(8px * ${scaleFactor})`
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          children: "\uD83D\uDCCD"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          children: info_address
        })]
      }), info_phone && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: {
          fontSize: `calc(0.85rem * ${scaleFactor})`,
          color: '#666',
          marginBottom: `calc(6px * ${scaleFactor})`,
          display: 'flex',
          alignItems: 'center',
          gap: `calc(8px * ${scaleFactor})`
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          children: "\uD83D\uDCDE"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
          href: `tel:${info_phone}`,
          style: {
            color: styles.primary_color,
            textDecoration: 'none'
          },
          children: info_phone
        })]
      }), info_hours && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        style: {
          fontSize: `calc(0.85rem * ${scaleFactor})`,
          color: '#666',
          display: 'flex',
          alignItems: 'flex-start',
          gap: `calc(8px * ${scaleFactor})`
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          children: "\uD83D\uDD50"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            whiteSpace: 'pre-line'
          },
          children: info_hours
        })]
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      style: {
        position: 'absolute',
        bottom: `calc(16px * ${scaleFactor})`,
        right: `calc(16px * ${scaleFactor})`,
        display: 'flex',
        gap: `calc(10px * ${scaleFactor})`,
        zIndex: 1000
      },
      children: [show_locate_button && /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
        onClick: getUserLocation,
        disabled: isLocating,
        style: {
          padding: `calc(12px * ${scaleFactor}) calc(20px * ${scaleFactor})`,
          fontSize: `calc(0.9rem * ${scaleFactor})`,
          fontWeight: '600',
          fontFamily: styles.font_family,
          background: userLocation ? `linear-gradient(135deg, #10B981, #059669)` : locationError ? `linear-gradient(135deg, #EF4444, #DC2626)` : `linear-gradient(135deg, #6B7280, #4B5563)`,
          color: '#fff',
          border: 'none',
          borderRadius: `calc(25px * ${scaleFactor})`,
          cursor: isLocating ? 'wait' : 'pointer',
          boxShadow: '0 4px 15px rgba(0,0,0,0.2)',
          display: 'flex',
          alignItems: 'center',
          gap: `calc(8px * ${scaleFactor})`,
          transition: 'all 0.3s ease',
          opacity: isLocating ? 0.7 : 1
        },
        onMouseEnter: e => {
          if (!isLocating) {
            e.currentTarget.style.transform = 'translateY(-2px)';
          }
        },
        onMouseLeave: e => {
          e.currentTarget.style.transform = 'translateY(0)';
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          style: {
            animation: isLocating ? 'pulse 1s infinite' : 'none'
          },
          children: isLocating ? '⏳' : userLocation ? '✅' : locationError ? '❌' : '📍'
        }), isLocating ? 'Localisation...' : locationError || locate_button_text]
      }), show_directions_button && /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
        onClick: handleDirectionsClick,
        style: {
          padding: `calc(12px * ${scaleFactor}) calc(20px * ${scaleFactor})`,
          fontSize: `calc(0.9rem * ${scaleFactor})`,
          fontWeight: '600',
          fontFamily: styles.font_family,
          background: `linear-gradient(135deg, ${styles.primary_color}, ${styles.secondary_color})`,
          color: '#fff',
          border: 'none',
          borderRadius: `calc(25px * ${scaleFactor})`,
          cursor: 'pointer',
          boxShadow: `0 4px 15px ${styles.primary_color}50`,
          display: 'flex',
          alignItems: 'center',
          gap: `calc(8px * ${scaleFactor})`,
          transition: 'all 0.3s ease'
        },
        onMouseEnter: e => {
          e.currentTarget.style.transform = 'translateY(-2px)';
          e.currentTarget.style.boxShadow = `0 6px 20px ${styles.primary_color}60`;
        },
        onMouseLeave: e => {
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.boxShadow = `0 4px 15px ${styles.primary_color}50`;
        },
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
          children: "\uD83E\uDDED"
        }), directions_button_text]
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("style", {
      children: `
                .custom-marker-icon {
                    background: transparent !important;
                    border: none !important;
                }
                
                .leaflet-popup-content-wrapper {
                    border-radius: 12px !important;
                    box-shadow: 0 4px 20px rgba(0,0,0,0.15) !important;
                }
                
                .leaflet-popup-tip {
                    box-shadow: none !important;
                }
                
                @keyframes pulse {
                    0%, 100% { opacity: 1; transform: scale(1); }
                    50% { opacity: 0.7; transform: scale(1.1); }
                }
            `
    })]
  });
};

// Export des constantes pour l'éditeur
var _default = exports.default = MapCell;